import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const meetings = [
  {
    time: "தினமும் காலை (6.25 -7.00) / இரவு (9.00-10.00)",
    description: "(தினமும் நம் சிந்தனை / பொது பகிர்வு/ஸ்பீக்கர் மீட்டிங்)",
    link: "https://join.freeconferencecall.com/banashree202013",
  },
  {
    time: "தினமும் காலை (7.00-8.30) / காலை (9.30-10.30) / மதியம் (1.00-2.30) / இரவு (7.00-8.30)",
    description: "(தினம் ஒரு தலைப்பு / தேர்வு செய்யும் தலைப்பு)",
    link: "https://join.freeconferencecall.com/higherpowergroup9",
  },
  {
    time: "தினமும் காலை (6.30-7.30) / காலை (10.30-12.00) / மதியம் (2.00-3.00) / மாலை (3.00-4.30) / மாலை (4.30-6.00) / இரவு (9.30-11.00)",
    description: "(பொது பகிர்வு / ஸ்பீக்கர் மீட்டிங் / தினமும் நம் சிந்தனை)",
    link: "https://join.freeconferencecall.com/adhijeevavina1",
  },
  {
    time: "தினமும் காலை (7.00-8.30) / மதியம் (1.00-2.00) / இரவு (7.00-8.30)",
    description: "(பொது பகிர்வு / தலைப்பு / ஸ்பீக்கர் மீட்டிங்)",
    link: "https://join.freeconferencecall.com/servicegroups2021",
  },
  {
    time: "தினமும் காலை (7.00-8.30)",
    description: "(பொது பகிர்வு / ஸ்பீக்கர் மீட்டிங் / தலைப்பு)",
    link: "https://join.freeconferencecall.com/jeyagandhi221",
  },
  {
    time: "தினமும் மதியம் (12.00-1.00)",
    description: "(7 நாள் 7 அட்டவணை)",
    link: "https://join.freeconferencecall.com/recoverygroupaa",
  },
  {
    time: "தினமும் மாலை (5.25-7.00)",
    description: "(தினம் ஒரு தலைப்பு)",
    link: "https://join.freeconferencecall.com/miracleonlinegroup1",
  },
  {
    time: "தினமும் இரவு (9.00-10.00)",
    description: "(பொதுபகிர்வு)",
    link: "https://join.freeconferencecall.com/primarypurposegroup1",
  },
  {
    time: "திங்கள் முதல் வெள்ளி வரை இரவு (9.30-10.30)",
    description: "(பில்லின் பார்வையில் ஏஏ / வாசிப்பு கலந்துரையாடல்)",
    link: "https://join.freeconferencecall.com/asbillseesitgroup",
  },
  {
    time: "சனிக்கிழமை காலை (8.00-9.30) / வியாழன் இரவு (7.00-8.30)",
    description: "(பெரிய புத்தகம் வாசித்தல்)",
    link: "https://join.freeconferencecall.com/roadtorecovery2021",
  },
  {
    time: "ஞாயிறு இரவு (7.00-8.30)",
    description: "",
    link: "https://join.freeconferencecall.com/threelegacies",
  },
];

export default function AAMeetingsPage() {
  const navigate = useNavigate();

  return (
    <section className="min-h-screen bg-gray-50 py-10 px-4 lg:px-8">
      <div className="max-w-5xl mx-auto">
        {/* Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 mb-8 text-blue-600 hover:underline text-lg font-medium"
        >
          <ArrowLeft className="w-5 h-5" />
          Back
        </button>

        <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">
          தமிழ் AA Online Meetings
        </h2>

        <div className="space-y-6">
          {meetings.map((m, i) => (
            <div
              key={i}
              className="bg-white p-5 rounded-xl shadow hover:shadow-lg transition-all border border-gray-100 text-gray-800"
            >
              <p className="font-semibold text-blue-600 mb-2">{i + 1}. {m.time}</p>
              <p className="mb-2 text-justify">{m.description}</p>
              <a
                href={m.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-700 font-medium hover:underline"
              >
                Join Meeting
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
